import React from 'react'
import style from './style.module.scss'
export const SearchEmpty = () => {
  return (
    <div className={style.wrapper}>
        <h1 className={style.title}>По вашему запросу ничего не найдено</h1>
    </div>
  )
}
